import { render, staticRenderFns } from "./ModuleCalendar.vue?vue&type=template&id=52a57bb1&scoped=true&lang=pug&"
import script from "./ModuleCalendar.vue?vue&type=script&lang=js&"
export * from "./ModuleCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ModuleCalendar.vue?vue&type=style&index=0&id=52a57bb1&lang=scss&scoped=true&"
import style1 from "./ModuleCalendar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a57bb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCalendar,VIcon,VSelect})
